import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import img from '../../../assets/referral/modal.jpg';
import Modal from 'components/ui/modal';
import ReferralCard from './ReferralCard';
import { useMutation, useQuery } from 'react-apollo';
import { GET_REFERRAL } from 'graphql/referral';
import { useSelector } from 'react-redux';
import { GET_REFERRAL_POPUP_DATE, UPSERT_REFERRAL_POPUP } from 'graphql/referral-popup-date';
import moment from 'moment';
import { toUserTimezone } from 'utils';

const styles = (theme) => ({
  img: {
    objectFit: 'contain',
    height: '100%',
    position: 'absolute',
    left: '15%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    [theme.breakpoints.down(800)]: {
      display: 'none',
    },
  },
  imgcontainer: {
    overflow: 'hidden',
  },
  modal: {
    padding: 0,
    paddingTop: '0!important',
  },
  content: {
    overflow: 'hidden',
    padding: '0px',
    marginLeft: '35%',
    // paddingTop: '10%',
    [theme.breakpoints.down(800)]: {
      margin: 'auto',
      height: '60%',
      overflow: 'auto',
    },
  },
  close: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  container: {
    '& > :nth-child(3) > div': {
      width: 800,
      maxWidth: 800,
      borderRadius: 0,
      [theme.breakpoints.down(800)]: {
        height: '60%',
      },
    },
  },
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: 0,
    paddingTop: 0,
  },
}))(MuiDialogContent);

const ReferralPopup = ({ classes }) => {

  const [style, setStyle] = useState('referral_popup')
  const user = useSelector((s) => s.user.user);
  const [upsertReferralPopup] = useMutation(UPSERT_REFERRAL_POPUP);
  const [showAddInvite, setShowAddInvite] = useState(false);

  const { data } = useQuery(GET_REFERRAL_POPUP_DATE, {
    variables: { type: 'referral' }, fetchPolicy: 'network-only',
  });
  const { data: referralData } = useQuery(GET_REFERRAL, {
    variables: { userId: user.id },
  });

  useEffect(() => {
    // do some checking here to ensure data exist
    if (referralData) {
      showPopupCondition();
    }
    if (data) {
      // console.log("this is jaggu data",data) //load data on componentMount
    }
  }, [referralData, data]);

  const showPopupCondition = () => {
    if (
      referralData === undefined ||
      referralData === '' ||
      data === undefined
    ) {
      return;
    } else {
      if (referralData.referrals.length === 0) {
        return;
      }
      if (data.show_popup_referral.length === 0) {
        // when no entry show popup
        setShowAddInvite(true);
      }
      isPopUp(); //check popup older than 7 days
    }
  };

  const isPopUp = () => {
    const resp = data;
    const currentDate = moment(toUserTimezone());
    const popupDate = resp?.show_popup_referral[0]?.popup_date;
    const waitDays = resp?.show_popup_referral[0]?.wait_days || 7;
    const diff = moment(currentDate).diff(popupDate, 'days');
    if (diff >= waitDays) {
      setShowAddInvite(true);
    }
  };

  const onCloseModal = () => {
    setShowAddInvite(false);
    updatePopupDate();
    window.analytics.track('Referral.InviteViaEmail.Cancelled');
  };

  const updatePopupDate = async () => {
    setShowAddInvite(false);
    await upsertReferralPopup({
      variables: {
        user_id: user.id,
        type: 'referral',
        waitDays: 7,
        popup_date: moment.utc(),
      },
    });
  };

  return (
    <>
      <Modal
        fullWidth
        open={showAddInvite}
        maxWidth="sm"
        className={classes.container}
      >
        <DialogContent className={classes.modal}>
          <IconButton className={classes.close} onClick={onCloseModal}>
            <CloseIcon />
          </IconButton>
          <Box>
            <Grid>
              <Grid className={classes.imgcontainer}>
                <img src={img} className={classes.img} alt=" " />
              </Grid>

              <Grid item xs={8} className={classes.content}>
                <ReferralCard style={style} referral={referralData?.referrals[0]} onSubmit={updatePopupDate} />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Modal>
    </>
  );
};

export default withStyles(styles)(ReferralPopup);
